import React from "react";
import { Navigate } from "react-router-dom";

export const AdminPrivateRoute = (props) => {
  const accessToken = localStorage.getItem("authToken");
  const userObject = localStorage.getItem("user");
  const isAuthenticated = accessToken && accessToken.length ? true : false;
  if (isAuthenticated) {
    return props.children;
    // if (JSON.parse(userObject)) {
    //   return props.children;
    // } else {
    //   return <Navigate to="/dashboard" />;
    // }
  } else {
    localStorage.removeItem("authToken");
    localStorage.removeItem("user");
    localStorage.removeItem("refresh");
    localStorage.removeItem("expiry");
    localStorage.removeItem("reset");
    return <Navigate to="/login" />;
  }
};
export const AuthRoute = (props) => {
  const accessToken = localStorage.getItem("authToken");
  const isAuthenticated = accessToken && accessToken.length ? true : false;
  return isAuthenticated ? <Navigate to="/dashboard" /> : props.children;
};
